import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  type TypographyProps,
  type AccordionProps,
  type TypographyVariant,
} from "@mui/material";
import { SyntheticEvent, useState } from "react";

interface NiapAccordionProps extends AccordionProps {
  title: string;
  headerVariant?: TypographyVariant;
  headerProps?: TypographyProps;
}

const NiapAccordion = ({
  title,
  children,
  headerVariant = "h4",
  elevation = 0,
  headerProps,
  ...accordionProps
}: NiapAccordionProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleChange = (_event: SyntheticEvent, expandValue: boolean) => {
    setIsOpen(expandValue);
  };

  return (
    <Accordion
      elevation={elevation}
      defaultExpanded
      disableGutters
      onChange={handleChange}
      {...accordionProps}
    >
      <AccordionSummary
        expandIcon={
          isOpen ? (
            <RemoveIcon fontSize="large" />
          ) : (
            <AddIcon fontSize="large" />
          )
        }
      >
        <Typography variant={headerVariant} {...headerProps}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default NiapAccordion;
